import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function SystemModulesContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  handleAddApplicationStatusModal,
  handleApplicationStatusEdit,
  handleApplicationStatusRemove,
  moduleId,
  showRequirement,
  moduleInfo,
}) {

  useEffect(() => {
    if (_.isEmpty(moduleId)) return;
    showRequirement(moduleId);
  }, [moduleId]);

  const renderStatus = (status) => {
    if (status) {
      return <div className="btn btn-sm btn-success">ACTIVE</div>;
    }
    return <div className="btn btn-sm btn-danger">INACTIVE</div>;
  };

  const app_status = _.get(moduleInfo, 'attributes.application_statuses');

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(moduleInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-9">
                  <h3 className="">
                    {_.get(moduleInfo, 'attributes.name') || '--'}
                  </h3>
                </div>
                <div className="col-3 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(moduleInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(moduleInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-4">
                    <img
                      className="w-100 rounded"
                      src={
                        !_.isObject(
                          _.get(moduleInfo, 'attributes.photo') || ''
                        )
                          ? _.get(moduleInfo, 'attributes.photo') ||
                            ImagePlaceholder
                          : _.get(moduleInfo, 'photo.cdnUrl') ||
                            ImagePlaceholder
                      }
                      alt=""
                    />
                  </div>
                  <div className="col">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="table-title">Name:</th>
                          <td>
                            {_.get(moduleInfo, 'attributes.name') || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Status:</th>
                          <td>
                            {renderStatus(
                              _.get(moduleInfo, 'attributes.is_active')
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Coming Soon:</th>
                          <td>
                            {renderStatus(
                              _.get(moduleInfo, 'attributes.is_coming_soon')
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Sequence:</th>
                          <td>
                            {_.get(moduleInfo, 'attributes.sequence') ||
                              '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Description:</th>
                          <td>
                            {_.get(moduleInfo, 'attributes.description') ||
                              '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Second Description:</th>
                          <td>
                            {_.get(
                              moduleInfo,
                              'attributes.description_2'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Tagalog Description:</th>
                          <td>
                            {_.get(
                              moduleInfo,
                              'attributes.description_filipino'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Category:</th>
                          <td>
                            {_.get(
                              moduleInfo,
                              'attributes.category'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Other Information:</th>
                          <td>
                            {_.get(
                              moduleInfo,
                              'attributes.other_information'
                            ) || '--'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="row d-flex justify-content-center w-100 border-top">
                    <div className="font-weight-bold col-12 mt-2 text-right">
                      <button
                        type="button"
                        onClick={handleAddApplicationStatusModal(moduleId)}
                        className="btn btn-primary btn-round font-weight-bold px-4"
                      >
                        Add&nbsp;
                        <i className="fas fa-plus" />
                      </button>
                    </div>
                  </div>
                  <div className="row d-flex justify-content-center w-100">
                    <div className="font-weight-bold col-12 mt-2 text-center">
                      Application Statuses
                    </div>
                    <div className="col-12">
                      <table className="table table-striped table-borderless">
                        <thead>
                          <tr>
                            <th>Description</th>
                            <th>Name</th>
                            <th>Tagalog Description</th>
                            <th>Amount</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {app_status && app_status.length ? (
                            _.get(
                              moduleInfo,
                              'attributes.application_statuses'
                            ).map((e) => (
                              <tr key={e.id}>
                                <td>{e.name}</td>
                                <td>{e.description}</td>
                                <td>{e.description_filipino || '--'} </td>
                                <td>{e.amount || '0.00'} </td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn-blank"
                                    onClick={handleApplicationStatusEdit(e)}
                                  >
                                    <i className="far fa-edit icon-edit" />
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-blank"
                                    onClick={handleApplicationStatusRemove(e)}
                                  >
                                    <i className="far fa-trash-alt icon-delete" />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data</td>
                              <td />
                              <td />
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

SystemModulesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleAddApplicationStatusModal: PropTypes.instanceOf(Function).isRequired,
  handleApplicationStatusEdit: PropTypes.instanceOf(Function).isRequired,
  handleApplicationStatusRemove: PropTypes.instanceOf(Function).isRequired,
  showRequirement: PropTypes.instanceOf(Function).isRequired,
  moduleInfo: PropTypes.instanceOf(Object).isRequired,
  moduleId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  moduleInfo: _.get(api, `${c.GET_SINGLE_MODULE}.item`) || {},
  moduleId: _.get(match, 'params.moduleId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SystemModulesContent);
